module.exports = {
      id: "Equipe_proxi-usage",
      viewBox: "0 0 420 230",
      url: __webpack_public_path__ + "../../../../skin/frontend/api/assets/mcp/svg/simulator/sprite.svg#Equipe_proxi-usage",
      toString: function () {
        return this.url;
      }
    }